<template>
  <div id="footer-bar" class="footer-bar-1">
    <router-link to="/admin">
      <i class="fa fa-home"></i><span>Home</span>
    </router-link>
    <router-link to="/admin/profile">
      <i class="fa fa-cog"></i><span>Profile</span>
    </router-link>
  </div>
</template>

<script>
export default {
name: "AdminFooter"
}
</script>

<style scoped>

</style>